export default class OrientacaoCreateOrientacaoController {
  constructor($q, $state, $scope, AuthenticationService, UIService, OrientacaoService, Orientacao, Orientando, GrauAcademico, Instituicao, OrientacaoTipo, Investigador, AreaInterdisciplinar, OrientacaoInvestigador, OrientacaoAreaInterdisciplinar, OrientacaoEstado) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.OrientacaoService = OrientacaoService;
    this.loaded = false;

    this.Orientacao = Orientacao;
    this.Orientando = Orientando;
    this.GrauAcademico = GrauAcademico;
    this.Instituicao = Instituicao;
    this.OrientacaoTipo = OrientacaoTipo;
    this.Investigador = Investigador;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.OrientacaoInvestigador = OrientacaoInvestigador;
    this.OrientacaoAreaInterdisciplinar = OrientacaoAreaInterdisciplinar;
    this.OrientacaoEstado = OrientacaoEstado;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.grausAcademicos = null;
    this.instituicoes = null;
    this.orientacoesTipo = null;
    this.orientacoesEstados = null;

    this.emptyData = {
      form: 1,
      details: {},

      orientando: {},
      orientadores: [],
      areas: [],
      auxGrau: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInstituicao: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxTipo: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxEstado: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInternational: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
    };

    // Configuration for date picker data
    this.dateOptions = {
      dataInicio: {format: 'DD/MM/YYYY'},
      dataFim: {format: 'DD/MM/YYYY'}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_OrientacaoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.GrauAcademico.find({}).$promise.then((grausAcademicos) => {
      this.grausAcademicos = grausAcademicos;
      this.Instituicao.find({}).$promise.then((instituicoes) => {
        this.instituicoes = instituicoes;
        this.OrientacaoTipo.find({}).$promise.then((orientacoesTipo) => {
          this.orientacoesTipo = orientacoesTipo;
          this.OrientacaoEstado.find({}).$promise.then((orientacoesEstados) => {
            this.orientacoesEstados = orientacoesEstados;
            this.loadDataFromStorage();
            this.loaded = true;
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Erro ao carregar estados de orientação. Verifique a sua ligação");
            this.state.go('app.orientacao.list');
          });
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro ao carregar tipos de orientação. Verifique a sua ligação");
          this.state.go('app.orientacao.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar nacionalidades. Verifique a sua ligação");
        this.state.go('app.orientacao.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar graus académicos. Verifique a sua ligação");
      this.state.go('app.orientacao.list');
    });
  };


  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_OrientacaoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_OrientacaoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);

      if (storageData.orientando) this.data.orientando = storageData.orientando; else this.data.orientando = angular.copy(this.emptyData.orientando);
      if (storageData.orientadores) this.data.orientadores = storageData.orientadores; else this.data.orientadores = angular.copy(this.emptyData.orientadores);
      if (storageData.areas) this.data.areas = storageData.areas; else this.data.areas = angular.copy(this.emptyData.areas);

      if (storageData.auxGrau) this.data.auxGrau = storageData.auxGrau; else this.data.auxGrau = angular.copy(this.emptyData.auxGrau);
      if (storageData.auxInstituicao) this.data.auxInstituicao = storageData.auxInstituicao; else this.data.auxInstituicao = angular.copy(this.emptyData.auxInstituicao);
      if (storageData.auxTipo) this.data.auxTipo = storageData.auxTipo; else this.data.auxTipo = angular.copy(this.emptyData.auxTipo);
      if (storageData.auxEstado) this.data.auxEstado = storageData.auxEstado; else this.data.auxEstado = angular.copy(this.emptyData.auxEstado);
      if (storageData.auxInternational) this.data.auxInternational = storageData.auxInternational; else this.data.auxInternational = angular.copy(this.emptyData.auxInternational);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.orientacao.new.' + this.data.form);
  };

  setForm = num => {
    // Special case - check for invalid URLs
    let ok = true;
    if (num === 2) {
      ok = this.OrientacaoService.isValidURL(this.data.details.url);
    }
    if (ok) {
      this.data.form = num;
      this.state.transitionTo('app.orientacao.new.' + this.data.form);
    } else {
      this.UI.addToast("URL Inválido");
    }
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.orientacao.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Orientacao and related data
      this.data.details.id = 0;
      this.data.details.grauId = this.data.auxGrau.selected.id;
      this.data.details.instituicaoId = this.data.auxInstituicao.selected.id;
      this.data.details.orientacaoTipoId = this.data.auxTipo.selected.id;
      this.data.details.estadoId = this.data.auxEstado.selected.id;
      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      // Create related data to orientando
      this.data.orientando.international = this.data.auxInternational.selected.value;

      // Create orientando so we can have the id for orientacao
      this.createOrientando(this.data.orientando).then((orientando) => {

        this.data.details.orientandoId = orientando.id;
        this.Orientacao.create(this.data.details).$promise.then((orientacao) => {

          // Create all Orientadores
          let deferOrientadores = this.$q.defer();
          this.OrientacaoService.createMultipleData(this.OrientacaoInvestigador, this.data.orientadores, orientacao.id, 'orientacaoId').then((x) => {
            deferOrientadores.resolve({ok: true});
          }).catch(err => {
            deferOrientadores.resolve({ok: false, output: 'Orientadores'});
          });

          // Create all Áreas
          let deferAreas = this.$q.defer();
          this.OrientacaoService.createMultipleData(this.OrientacaoAreaInterdisciplinar, this.data.areas, orientacao.id, 'orientacaoId').then((x) => {
            deferAreas.resolve({ok: true});
          }).catch(err => {
            deferAreas.resolve({ok: false, output: 'Indicadores'});
          });

          let promises = [deferOrientadores.promise, deferAreas.promise];

          // After all multiple data information is created/settled
          this.$q.all(promises).then((res) => {
            this.UI.addToast("Orientação criada com sucesso");

            localStorage.removeItem('ISR_SGI_OrientacaoNewForm');

            let error = this.createdMultipleDataOk(res);
            if (error) {
              let errorMessage = "Orientação criada, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
              alert = this.UI.showAlert(errorMessage);
              alert.finally(() => {
                // Redirect to details view so it can be filled
                this.state.go('app.orientacao.details', {id: orientacao.id});
              });
            } else {
              this.state.go('app.orientacao.list');
            }
          }).catch(err => { // Should never happen, since resolving everything...
            console.log(err);
            localStorage.removeItem('ISR_SGI_OrientacaoNewForm');
            alert = this.UI.showAlert("Orientação criada, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.orientacao.details', {id: orientacao.id});
            });
          });
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao criar orientação. Verifique a ligação");
          this.loaded = true;
        });
      }).catch(error => {
        console.log(error);
        this.UI.showAlert("Erro ao criar orientando. Verifique a ligação");
        this.loaded = true;

      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  createOrientando = (orientando) => {
    let defer = this.$q.defer();
    orientando.id = 0;
    orientando.criadoPorId = this.user.id;
    orientando.dataCriacao = moment().format();
    orientando.atualizadoPorId = this.user.id;
    orientando.atualizadoa = moment().format();
    this.Orientando.create(orientando).$promise.then((novoOrientando) => {
      if (novoOrientando) defer.resolve(novoOrientando);
      else defer.reject();
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };


  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if orientação data is well defined
    // Título do Trabalho
    if (v && (!this.data.details.titulo || this.data.details.titulo.length === 0)) {
      this.UI.addToast("Título do Trabalho não preenchido");
      v = false;
      validDefer.reject();
    }

    // Designação / Curso do Orientando
    if (v && (!this.data.details.designacao || this.data.details.designacao.length === 0)) {
      this.UI.addToast("Designação / Curso do Orientando não preenchido");
      v = false;
      validDefer.reject();
    }

    // Data de Início
    if (v && (!moment(this.data.details.dataInicio).isValid())) {
      this.UI.addToast("Data de Início inválida");
      v = false;
      validDefer.reject();
    }

    // Grau Académico
    if (v && (!this.data.auxGrau || !this.data.auxGrau.selected)) {
      this.UI.addToast("Grau Académico inválido");
      v = false;
      validDefer.reject();
    }

    // Aluno Internacional
    if (v && (!this.data.auxInternational || !this.data.auxInternational.selected)) {
      this.UI.addToast("Aluno Internacional não preenchido");
      v = false;
      validDefer.reject();
    }

    // Instituição
    if (v && (!this.data.auxInstituicao || !this.data.auxInstituicao.selected)) {
      this.UI.addToast("Instituição inválida");
      v = false;
      validDefer.reject();
    }

    // Tipo de Orientação
    if (v && (!this.data.auxTipo || !this.data.auxTipo.selected)) {
      this.UI.addToast("Tipo de Orientação inválida");
      v = false;
      validDefer.reject();
    }

    // Estado da Orientação
    if (v && (!this.data.auxEstado || !this.data.auxEstado.selected)) {
      this.UI.addToast("Estado da Orientação inválida");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data
    if (v && (this.data.orientadores.length === 0)) {
      this.UI.addToast("Orientadores não preenchidos");
      v = false;
      validDefer.reject();
    }
    if (v && (this.data.areas.length === 0)) {
      this.UI.addToast("Áreas Interdisciplinares não preenchidas");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.areas.length > 3)) {
      this.UI.addToast("Só podem ser adicionadas 3 áreas interdisciplinares");
      v = false;
      validDefer.reject();
    }


    // Check if data is unique for multiple data
    // Orientadores (only check investigadores ISR for repeats)
    let investigadores = this.data.orientadores.filter(x => x.investigadorId !== null).map(x => x.investigadorId);
    let investigadoresRepetidos = investigadores.filter((x, i) => investigadores.indexOf(x) !== i);
    if (v && investigadoresRepetidos.length > 0) {
      this.UI.addToast("Orientadores repetidos");
      v = false;
      validDefer.reject();
    }
    // Áreas Interdisciplinares
    let areas = this.data.areas.map(x => x.areaId);
    let areasRepetidas = areas.filter((x, i) => areas.indexOf(x) !== i);
    if (v && areasRepetidas.length > 0) {
      this.UI.addToast("Áreas Interdisciplinares repetidas");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // Add multi async data to verify
      this.data.orientadores.forEach(x => {
        if (x.investigadorId) {
          idData.push({
            field: 'id',
            value: x.investigadorId,
            model: this.Investigador,
            resolveOnExist: true, // It's resolved if it finds one
            error: "Investigador inexistente"
          });
        }
      });
      this.data.areas.forEach(x => {
        idData.push({
          field: 'id',
          value: x.areaId,
          model: this.AreaInterdisciplinar,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Área Interdisciplinar inexistente"
        });
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.OrientacaoService.validateMultiData(idData).then(x => {
        wait.close();
        validDefer.resolve();
      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs

  // Adicionar um novo orientador para orientação
  addOrientador = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.orientacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.orientador = {};
          $scope.label = "Adicionar Orientador";
          $scope.investigadores = investigadores;
          $scope.isInvestigador = false;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Called just before switch is toggled, so logic is reversed
          $scope.onSwitch = () => {
            if ($scope.isInvestigador) { // We clicked to do Other Autor, clear selection
              $scope.auxInvestigador.selected = undefined;
            } else { // We clicked to do Investigador, clear other data
              $scope.orientador = {};
            }
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.orientador) {
          let item = angular.copy(ok.orientador);

          if (ok.isInvestigador && ok.auxInvestigador.selected) {
            item.investigadorId = ok.auxInvestigador.selected.id;
            item.investigador = angular.copy(ok.auxInvestigador.selected);
          } else if (!ok.isInvestigador && ok.orientador.orientador) {
            item.investigadorId = null;
            item.orientador = ok.orientador.orientador;
          }

          this.data.orientadores.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para orientação. Verifique a sua ligação");
    });
  };

  // Edita informação de orientador para orientação
  editOrientador = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.orientacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.orientador = angular.copy(x);
          $scope.label = "Editar Orientador";
          $scope.investigadores = investigadores;
          $scope.isInvestigador = $scope.orientador.investigador !== undefined;

          $scope.auxInvestigador = {
            selected: $scope.orientador.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Called just before switch is toggled, so logic is reversed
          $scope.onSwitch = () => {
            if ($scope.isInvestigador) { // We clicked to do Other Autor, clear selection
              $scope.auxInvestigador.selected = undefined;
            } else { // We clicked to do Investigador, clear other data
              $scope.orientador = {};
            }
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.orientador) {
          if (ok.isInvestigador && ok.auxInvestigador.selected) {
            x.investigadorId = ok.auxInvestigador.selected.id;
            x.investigador = angular.copy(ok.auxInvestigador.selected);
            x.orientador = null;
          } else if (!ok.isInvestigador && ok.orientador.orientador) {
            delete x.investigador;
            x.investigadorId = null;
            x.orientador = ok.orientador.orientador;
          }
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para orientação. Verifique a sua ligação");
    });
  };

  // Remove Orientador com índice index
  removeOrientador = (index) => {
    if (index < this.data.orientadores.length) {
      this.data.orientadores.splice(index, 1);
    }
  };


  // Adicionar uma nova área interdisciplinar para orientação
  addArea = () => {
    // Only allow a max of 3 areas
    if (this.data.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = {};
          $scope.label = "Adicionar Área Interdisciplinar à Orientação";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          let item = angular.copy(ok.area);

          item.areaId = ok.auxArea.selected.id;
          item.area = ok.auxArea.selected;

          this.data.areas.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para orientação. Verifique a sua ligação");
    });

  };

  // Edita informação de área interdisciplinar para orientação
  editArea = (x) => {
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
      size: 'lg',
      template: require('./edit.area.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.area = angular.copy(x);
        $scope.label = "Editar Área Interdisciplinar da Orientação";
        $scope.areas = areas;

        $scope.auxArea = {
          selected: $scope.area.area,
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.auxArea && ok.area) {
        x.areaId = ok.auxArea.selected.id;
        x.area = angular.copy(ok.auxArea.selected);
      }
    });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para orientação. Verifique a sua ligação");
    });
  };

  // Remove área interdisciplinar com índice index
  removeArea = (index) => {
    if (index < this.data.areas.length) {
      this.data.areas.splice(index, 1);
    }
  };

}

OrientacaoCreateOrientacaoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'OrientacaoService', 'Orientacao', 'Orientando', 'GrauAcademico', 'Instituicao', 'OrientacaoTipo', 'Investigador', 'AreaInterdisciplinar', 'OrientacaoInvestigador', 'OrientacaoAreaInterdisciplinar', 'OrientacaoEstado'];
